import { defer } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { select } from '@ngrx/store';

import type { Entity, FirebaseEntity } from '@bp/shared/models/metadata';
import { filterPresent } from '@bp/shared/rxjs';

import type { EntitiesInMemoryPagedListSelectors } from './compose-entities-list-selectors';
import { EntitiesListFacade } from './entities-list.facade';
import type { EntitiesListActions } from './entities.actions';

@Injectable({ providedIn: 'root' })
export abstract class EntitiesInMemoryPagedListFacade<
	TEntity extends Entity | FirebaseEntity,
	TLoadQueryParams
> extends EntitiesListFacade<TEntity, TLoadQueryParams> {

	abstract override readonly actions: EntitiesListActions<TEntity, TLoadQueryParams>;

	abstract override readonly selectors: EntitiesInMemoryPagedListSelectors<TEntity>;

	readonly all$ = defer(() => this._store$.pipe(
		select(this.selectors.all),
		tap(v => (this.all = v)),
	));

	all!: TEntity[] | null;

	readonly allPresent$ = this.all$.pipe(filterPresent);

	readonly filteredInMemory$ = defer(() => this._store$.pipe(
		select(this.selectors.filteredInMemory),
	));

	readonly filteredInMemoryLength$ = this.filteredInMemory$.pipe(
		map(filteredInMemory => filteredInMemory?.length ?? null),
	);

	loadAll(): void {
		this._store$.dispatch(this.actions.loadAll());
	}
}
